export const initAccordionItems = (): void => {
  const accordionItems: NodeListOf<HTMLElement> = document.querySelectorAll('.js-accordion-item');

  if (!accordionItems.length) {
    return;
  }

  accordionItems.forEach((accordionItem: HTMLElement): void => {
    const accordionHeaders: NodeListOf<HTMLElement> =
      accordionItem.querySelectorAll('.js-accordion-header');

    accordionHeaders.forEach((header: HTMLElement): void => {
      header.addEventListener('click', (): void => {
        accordionItem.classList.toggle('active');

        const content: Element | null = accordionItem.querySelector('.js-accordion-content');
        const icon: HTMLElement | null = header.querySelector('.js-accordion-icon');

        if (!content || !icon) {
          return;
        }

        if (accordionItem.classList.contains('active')) {
          content.classList.remove('hidden');
          icon.classList.add('rotate-180');
        } else {
          content.classList.add('hidden');
          icon.classList.remove('rotate-180');
        }
      });
    });
  });
};
